<template>
  <b-navbar toggleable="lg" type="dark" fixed="top"
    :variant="currentUser ? 'black' : 'transparent'">
    <b-container>
      <b-navbar-brand to="/">
        <b-img src="/img/logo.svg" alt="FCBarcelona Hospitality" height="38"></b-img>
      </b-navbar-brand>
      <div class="psl__navbar-user align-self-center small px-2 border-left border-light align-right d-md-none ml-auto"
        v-if="currentUser">
        {{currentUser.name}} {{currentUser.surname}}
        <br />
        <strong>{{currentUser.admin ? 'PSL Admin' : 'PSL Assistant'}}</strong>
      </div>
      <b-navbar-nav class="ml-auto"
        v-if="!currentUser">
        <b-nav-item-dropdown right no-caret variant="link">
          <template #button-content>
            <b-icon icon="globe" aria-hidden="true"></b-icon>
          </template>
          <b-dropdown-item href="#" active>Español</b-dropdown-item>
          <b-dropdown-item href="#">Català</b-dropdown-item>
          <b-dropdown-item href="#">English</b-dropdown-item>
          <b-dropdown-item href="#">Français</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <template
        v-else>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto psl__navigation-main">
            <b-nav-item active-class="active" class="px-lg-2 text-uppercase d-flex align-items-center"
              :to="{name: 'users'}"
              v-if="currentUser.admin">
              <b-icon icon="person-badge" aria-hidden="true" class="mr-2"></b-icon>Gestión usuarios
            </b-nav-item>
            <b-nav-item active-class="active" class="px-lg-2 text-uppercase d-flex align-items-center"
              :to="{name: 'matches'}">
              <b-icon icon="collection" aria-hidden="true" class="mr-2"></b-icon>Gestión localidades
            </b-nav-item>
            <b-nav-item active-class="active" class="px-lg-2 text-uppercase d-flex align-items-center"
              :to="{name: 'club'}">
              <b-icon icon="briefcase" aria-hidden="true" class="mr-2"></b-icon>Business Club
            </b-nav-item>
            <b-nav-item active-class="active" class="px-lg-2 text-uppercase d-flex align-items-center"
              :to="{name: 'notifications'}">
              <b-icon icon="bell" aria-hidden="true" class="mr-2"></b-icon>Comunicaciones
            </b-nav-item>
            <div class="psl__navbar-user align-self-center small px-2 border-left border-light ml-2 align-right d-none d-lg-block text-right">
              {{currentUser.name}} {{currentUser.surname}}
              <br />
              <strong>{{currentUser.admin ? 'PSL Admin' : 'PSL Assistant'}}</strong>
            </div>
            <div class="psl__navigation-exit align-self-lg-center px-lg-2 ml-lg-2 d-flex align-items-center mb-1 text-uppercase" role="button"
              @click="exit">
              <b-icon icon="box-arrow-right" aria-hidden="true" class="mr-2 mr-lg-0"></b-icon><span class="d-lg-none">Cerrar sesión</span>
            </div>
            <b-nav-item-dropdown right no-caret class="psl__navigation-lang">
              <template #button-content>
                <div class="d-flex align-items-center">
                  <b-icon icon="globe" aria-hidden="true" class="mr-2 mr-lg-0"></b-icon><span class="d-lg-none">Idiomas</span>
                </div>
              </template>
              <b-dropdown-item href="#" active>Español</b-dropdown-item>
              <b-dropdown-item href="#">Català</b-dropdown-item>
              <b-dropdown-item href="#">English</b-dropdown-item>
              <b-dropdown-item href="#">Français</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </template>
    </b-container>

  </b-navbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NavigationBar',
  computed: {
    ...mapState(['currentUser'])
  },
  methods: {
    resetUser() {
      this.$store.commit('setUser', {email: '', password: ''});
      if (this.$route.name != 'home')
        this.$router.push({name: 'home'});
    },
    exit() {
      this.$bvModal.msgBoxConfirm(['Puedes volver a iniciar sesión en cualquier momento.', this.$createElement('br'), '¿Deseas continuar?'], {
        title: 'Cerrar sesión',
        okVariant: 'primary',
        okTitle: 'ACEPTAR',
        cancelVariant: 'link',
        cancelTitle: 'CANCELAR',
        footerClass: 'justify-content-center border-0',
        hideHeaderClose: false,
        centered: true,
        bodyClass: 'text-center',
        headerClass: 'text-uppercase align-items-center'
      })
      .then(value => {
        if (value)
          this.resetUser();
      });
    }
  }
}
</script>
